/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-function-type */
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import React, {Fragment} from 'react';
import {DimensionValue, Platform, ScrollView, Text, View} from 'react-native';
import {connect} from 'react-redux';
import {
  autoPhotoLabels,
  listDuree,
} from '../../../../data/constants/Contrats/contratRattacher';
import {thousandSeparator} from '../../../../data/factory';
import {
  IErrors,
  IShowErrors,
  IValues,
} from '../../../../data/types/interface/Contrats/contratRattacher';
import {useContratRattached} from '../../../../hooks/Contrat Rattacher/useForm';
import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import {buttonsStyles} from '../../../components/Button/boutonStyle';
import PrimaryButton from '../../../components/Button/PrimaryButton';
import AcceptTermCheckbox from '../../../components/Inputs/Checkbox';
import {InputDatePicker} from '../../../components/Inputs/InputDatePicker';
import {InputImage} from '../../../components/Inputs/InputImage';
import Select from '../../../components/Inputs/Select/index';
import inputStyles from '../../../components/Inputs/styles';
import {Loader} from '../../../components/Loader';
import ConfirmationModal from '../../../components/Modal/ConfirmationModal';

interface ContratRattacheFormScreenProps {
  show: boolean;
  onClose: () => void;
  onSubmit: () => void;
  contratEnCoursUser: Function;
  detailsContrat: Record<string, any>;
  user: any;
}

const ContratRattacheFormScreen = ({
  onClose,
  onSubmit,
  contratEnCoursUser = () => {},
  detailsContrat,
  user = undefined,
}: ContratRattacheFormScreenProps) => {
  const typeContrat = detailsContrat.typeContratPayment;

  const {
    values,
    errors,
    showErrors,
    handleChange,
    handleSubmit,
    loadingAmount,
    loadingSubmit,
    isEmpty,
    errorMessage,
    clearErrorMessage,
  } = useContratRattached(
    contratEnCoursUser,
    String(detailsContrat.numeroPolice),
    onSubmit,
    onClose,
    user,
    (typeContrat as string) ?? '',
    detailsContrat.dateEcheance,
  );

  return (
    <ScrollView>
      <View
        style={{
          flex: 1,
          padding: 20,
          minHeight: '66vh' as DimensionValue,
          justifyContent: Platform.OS == 'web' ? 'center' : 'flex-start',
        }}>
        {/** FORMS */}
        <View
          style={{
            width: '100%',
            alignItems: 'center',
          }}>
          {loadingAmount ? (
            <Loader />
          ) : (
            <Text
              style={{
                width: '100%',
                fontSize: 16,
                textAlign: 'center',
                fontWeight: 'bold',
              }}>
              {values.amount
                ? `${thousandSeparator(String(values.amount), '')} Ar`
                : ''}
            </Text>
          )}
        </View>
        <View style={{width: '100%', zIndex: 1000}}>
          <InputDatePicker
            label={'Date de couverture (debut)'}
            required
            value={values.dateDebut}
            name="dateDebut"
            onChange={handleChange}
            error={errors.dateDebut}
            showError={showErrors.dateDebut}
            dateMin={
              dayjs().isSameOrAfter(
                dayjs(detailsContrat.dateEcheance, 'DD/MM/YYYY'),
                'day',
              )
                ? typeContrat != 'auto'
                  ? dayjs().add(1, 'day').toDate()
                  : dayjs().toDate()
                : dayjs(detailsContrat.dateEcheance, 'DD/MM/YYYY')
                    .add(1, 'day')
                    .toDate()
            }
            noInit
          />
        </View>
        {typeContrat != 'auto' && (
          <Select
            style={{flex: 1}}
            data={listDuree}
            label="Durée"
            defaultValue={listDuree[0].value}
            required={true}
            onChange={(name: string, data: any) => {
              handleChange('duration', data);
            }}
            value={values.duration}
            error={errors.duration}
            showError={showErrors.duration}
          />
        )}
        {typeContrat == 'auto' && (
          <Fragment>
            {values.amount && values.arePhotosRequired && (
              <View>
                {autoPhotoLabels.map(label => (
                  <InputImage
                    key={label.name}
                    label={label.label}
                    required={values.arePhotosRequired}
                    name={label.name}
                    onChange={(
                      _n: string,
                      value: any,
                      _: boolean,
                      remove: boolean,
                    ) => {
                      handleChange(label.name as keyof IValues, value, remove);
                    }}
                    value={values[label.name as keyof IValues]}
                    maxLength={1}
                    error={errors[label.name as keyof IErrors]}
                    showError={showErrors[label.name as keyof IShowErrors]}
                  />
                ))}
              </View>
            )}
            <View style={{width: '100%'}}>
              <AcceptTermCheckbox
                changeValue={(value: boolean) => {
                  handleChange('acceptTerm', value);
                }}
                value={values.acceptTerm}
                text={
                  <Text
                    style={{
                      margin: 8,
                    }}>
                    Je confirme avoir pris connaissance du{' '}
                    <Text style={{fontWeight: 'bold'}}>montant</Text> indiqué et
                    l'accepte.
                  </Text>
                }
              />
              <Text style={inputStyles.textError}>
                {showErrors['acceptTerm'] && errors['acceptTerm'] !== ''
                  ? errors['acceptTerm']
                  : ''}
              </Text>
            </View>
          </Fragment>
        )}

        {/* BUTTONS */}
        <View
          style={[
            buttonsStyles.displayCenter,
            {
              // flex: 0,
              flexDirection: 'row',
              width: '100%',
              paddingTop: 5,
              paddingHorizontal: 20,
              backgroundColor: 'white',
            },
          ]}>
          {loadingSubmit ? (
            <Loader />
          ) : (
            <Fragment>
              <PrimaryButton
                onPress={() => onClose()}
                styleBtnTxt={buttonsStyles.btnAnnuler}
                styleBtnOuter={buttonsStyles.btnAnnulerOuterSimu}
                title="Annuler"
                type="annuler"
              />
              <PrimaryButton
                onPress={() => handleSubmit()}
                styleBtnTxt={buttonsStyles.btnValider}
                styleBtnOuter={buttonsStyles.btnValiderOuterSimu}
                title="Valider"
                type="valider"
                isDisable={isEmpty}
              />
            </Fragment>
          )}
        </View>
      </View>
      {errorMessage && (
        <ConfirmationModal
          title="Erreur"
          content={errorMessage}
          btn1="OK"
          handleBtn1={clearErrorMessage}
        />
      )}
    </ScrollView>
  );
};

export const ContratRattacheForm: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContratRattacheFormScreen);
